let started = false;

/**
 * Enforces one active voice message across the entire web application.
 * The native play event does not bubble, so capture is required.
 */
export function startSingleAudioPlayback() {
  if (started) return;
  started = true;

  document.addEventListener("play", (event) => {
    const nextAudio = event.target;
    if (!(nextAudio instanceof HTMLAudioElement)) return;

    document.querySelectorAll("audio").forEach((otherAudio) => {
      if (otherAudio !== nextAudio && !otherAudio.paused) {
        otherAudio.pause();
      }
    });
  }, true);
}
